import { PagePermissionDto, PagePermissionResponseDto } from 'models/auth/pagepermissions';
import { ApiServiceBase } from './base/api-service-base';
import { IPublicClientApplication } from '@azure/msal-browser';
import { IApiService } from 'api/interfaces/api-service';
import { IAppConfigService } from 'api/interfaces/app-config-service';

const baseEndpoint = 'auth';

export interface IAuthApiService {
	GetAuthorizedPages(): Promise<PagePermissionResponseDto>;
}

export class AuthApiService extends ApiServiceBase implements IAuthApiService {
	private msalInstance: IPublicClientApplication | null = null;

	constructor(
		apiService: IApiService, 
		appConfigService: IAppConfigService, 
		msalInstance?: IPublicClientApplication
	) {
		super(apiService, appConfigService);
		if (msalInstance) {
			this.msalInstance = msalInstance;
		}
	}

	public initialize(msalInstance: IPublicClientApplication): void {
		this.msalInstance = msalInstance;
	}

	public async GetAuthorizedPages(): Promise<PagePermissionResponseDto> {
		return await this.GetFromApi(`${baseEndpoint}/permissions`);
	}
}